export default __webpack_public_path__ + "static/media/forward.a1b55e53.svg";